import React from 'react'
import { useUserStore } from "../store/AuthUserStore";
import PieceWorkDashboardAdmin from '../component/PieceWorkDashboardAdmin';
 
const Dashborad : React.FC = () => {

  const user = useUserStore((state) => state.user);

  console.log("user",user)

  return <PieceWorkDashboardAdmin/>;
}

export default Dashborad
